export const getAvailableCreditBalance = (benefitResponse) => {
    const creditBalances = benefitResponse?.benefits?.find((benefit) => benefit.id === 1)?.balances;

    return Number(
        creditBalances?.find((balance) => balance.name === "Balance Diario Disponible")?.amount ??
            creditBalances?.find((balance) => balance.name === "Balance Disponible")?.amount ??
            0,
    );
};

export const getAvailableGiftCardBalance = (giftCards = []) =>
    Number(
        giftCards
            .reduce((total, giftCard) => {
                const amount = Number(giftCard.amount);
                return Number.isFinite(amount) ? total + amount : total;
            }, 0)
            .toFixed(2),
    );

export const getTotalAvailableBenefits = (benefitResponse, giftCards = []) => {
    const benefitBalance = Number(
        benefitResponse?.availableBalance ?? getAvailableCreditBalance(benefitResponse),
    );
    const giftCardBalance = Math.max(getAvailableGiftCardBalance(giftCards), 0);

    return Number((benefitBalance + giftCardBalance).toFixed(2));
};
